import type { ChatMessage } from './types';

/**
 * Whether the form attached to `message` should render as already submitted.
 * Repeatable forms track per message; others by form_id, so every copy disables.
 */
export function isFormSubmitted(
  message: ChatMessage,
  submittedFormIds: Set<string>,
): boolean {
  const form = message.displayForm;
  if (!form) return false;
  return form.allow_multiple_submissions
    ? !!message.submitted
    : submittedFormIds.has(form.form_id);
}
